module.exports = __webpack_public_path__ + "static/ClickedOverseasAndSingapore-89cf12f2b26761ae79dd82dd748178fc.png";